import { useContext, useEffect, useState } from 'react';
import { NavigationContext } from '@react-navigation/native';

export const useIsFocusedSafe = (): boolean => {
  const navigation = useContext(NavigationContext);
  const [isFocused, setIsFocused] = useState(true);

  useEffect(() => {
    if (!navigation) return;
    const update = () => setIsFocused(navigation.isFocused());
    update();
    const unsubFocus = navigation.addListener('focus', update);
    const unsubBlur = navigation.addListener('blur', update);
    return () => {
      unsubFocus();
      unsubBlur();
    };
  }, [navigation]);

  return navigation ? isFocused : true;
};
